import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Adresse, Campus, ChoixDocumentation, Consentement, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useUrlReturn } from "hooks"
import { adresse, consent, consentement, defaultValues, getCampus, salutations, specialities } from "services"
import MentionsLegales from "components/MentionsLegales"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('SUPBIO-DOC')
  const { url: url_brochure } = useUrlReturn('SUPBIO-DOC-BROCHURE')
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      ...specialities,
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        ...adresse,
        Salutation: '',
        Section__c: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campus = lead.Campus__c
    const defaultDataLead = {
      Division__c: `SupBiotech`,
      IONISSchool__c: `SupBiotech`,
      LastForm__c: 'Documentation PDF',
      LeadSource: 'Internet: Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      await salesforce.createLead(finalLead)
      const redirectUrl = choix === 'telecharger' ? url : url_brochure
      document.location.href = `${redirectUrl}?campus=${campus}&niveau=${encodeURIComponent(lead.AcademicLevel__c)}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const choix = watch('choix')
  // useEffect
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <ChoixDocumentation />
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel school="SupBiotech" />
        <Campus label="Campus souhaité" options={getCampus(`SupBiotech`)} />
        {choix === 'recevoir' && (
          <Adresse />
        )}
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Documentation" school="SupBiotech" />
      </Grid>
    </FormProvider>
  )
}

export default Form
